<gax-page>
  <gax-page-header>
    <gax-page-header-title>Not Found</gax-page-header-title>
    <gax-page-header-description>
      The requested resource was not found or no longer exists.
    </gax-page-header-description>
  </gax-page-header>
</gax-page>
